
















































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Placeholder from '@tiptap/extension-placeholder';
import Highlight from '@tiptap/extension-highlight';
import Underline from '@tiptap/extension-underline';
import {
  addBlog,
  updateBlog,
  deleteBlog,
  publishBlog,
  unpublishBlog,
  getBlogByUuid,
} from '@/utils/blogs/add-blog/add-blog-util';
import { Blog } from '@/resource/blog/blog.model';
import 'vue-good-table/dist/vue-good-table.css';
import LoadingBox from '@/components/common/LoadingBox.vue';
import Iframe from '@/utils/blogs/add-blog/editor-iframe';
import Link from '@tiptap/extension-link';
import { ErrorResponse } from '@/utils/response';
import AddQuestionUpload from '@/components/add-question/AddQuestionUpload.vue';

@Component({
  components: { LoadingBox, EditorContent, AddQuestionUpload },
})
export default class BlogEditor extends Vue {
  blog: Blog = {
    title: '',
    content: '',
    contentHtml: '',
    description: '',
    viewCount: 0,
    duration: 0,
    order: undefined,
    thumbnail:
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80',
    publishedAt: undefined,
  };

  editor: any = null;

  isLoading = false;
  isConfirmingDelete = false;

  get blogUuid() {
    return this.$route.params.uuid;
  }

  async created() {
    await this.fetchBlog();
  }

  async fetchBlog() {
    this.isLoading = true;
    if (this.blogUuid) {
      const {
        title,
        description,
        thumbnail,
        duration,
        content,
        publishedAt,
        order,
      } = await getBlogByUuid(this.blogUuid);

      this.blog.title = title;
      this.blog.description = description;
      this.blog.thumbnail = thumbnail;
      this.blog.duration = duration;
      this.blog.publishedAt = publishedAt;
      this.blog.order = order;
      this.editor.commands.setContent(content);
    }
    this.isLoading = false;
  }

  onContentChange(value: any) {
    // HTML
    const isSame = this.editor.getHTML() === value;

    if (isSame) {
      return;
    }

    this.editor.commands.setContent(value, false);
  }

  addImage() {
    const url = window.prompt('URL');

    if (url) {
      this.editor
        .chain()
        .focus()
        .setImage({ src: url })
        .run();
    }
  }

  addIframe() {
    const url = window.prompt('Embed');

    if (url) {
      this.editor
        .chain()
        .focus()
        .insertContent(url)
        .run();
    }
  }

  setLink() {
    const url = window.prompt('URL') || '';

    this.editor
      .chain()
      .focus()
      .extendMarkRange('link')
      .setLink({ href: url })
      .run();
  }

  mounted() {
    this.editor = new Editor({
      extensions: [
        Image,
        StarterKit,
        Placeholder,
        Iframe,
        Link,
        Underline,
        Highlight.configure({ multicolor: true }),
      ],
    });
  }

  beforeDestroy() {
    this.editor.destroy();
  }

  async addNewBlog() {
    this.isLoading = true;

    const params = {
      content: this.editor.getJSON(),
      contentHtml: this.editor.getHTML(),
      title: this.blog.title,
      viewCount: this.blog.viewCount,
      description: this.blog.description,
      thumbnail: this.blog.thumbnail,
      duration: this.blog.duration,
      order: this.blog.order ? this.blog.order : undefined,
    };
    try {
      const { uuid } = await addBlog(params);
      this.$router.push({ path: '/blog-editor/' + uuid });
    } catch (err) {
      const error: ErrorResponse = err as any;
      this.$toasted.global.mainToast({
        message:
          `ERROR: ${error.message}` +
          (error.errors ? ` ${error.errors[0].field}` : ` `),
      });
    }
    this.isLoading = false;
  }

  async updateBlog() {
    this.isLoading = true;

    const params = {
      content: this.editor.getJSON(),
      contentHtml: this.editor.getHTML(),
      title: this.blog.title,
      viewCount: this.blog.viewCount,
      description: this.blog.description,
      thumbnail: this.blog.thumbnail,
      duration: this.blog.duration,
      order: this.blog.order ? this.blog.order : undefined,
    };

    try {
      await updateBlog(this.blogUuid, params);
    } catch (err) {
      const error: ErrorResponse = err as any;
      this.$toasted.global.mainToast({
        message:
          `ERROR: ${error.message}` +
          (error.errors ? ` ${error.errors[0].field}` : ` `),
      });
    }

    this.isLoading = false;
  }

  async publishBlog() {
    this.isLoading = true;
    try {
      const { publishedAt } = await publishBlog(this.blogUuid);
      this.blog.publishedAt = publishedAt;
    } catch (err) {
      const error: ErrorResponse = err as any;
      this.$toasted.global.mainToast({
        message:
          `ERROR: ${error.message}` +
          (error.errors ? ` ${error.errors[0].field}` : ` `),
      });
    }
    this.isLoading = false;
  }

  async unpublishBlog() {
    this.isLoading = true;
    try {
      const { publishedAt } = await unpublishBlog(this.blogUuid);
      this.blog.publishedAt = publishedAt;
    } catch (err) {
      const error: ErrorResponse = err as any;
      this.$toasted.global.mainToast({
        message:
          `ERROR: ${error.message}` +
          (error.errors ? ` ${error.errors[0].field}` : ` `),
      });
    }
    this.isLoading = false;
  }

  async deleteBlog() {
    this.isLoading = true;
    await deleteBlog(this.blogUuid);
    this.isLoading = false;
  }
}
